/* =====================================================================
   LUMIQO — lq-sticky-shop-bar.js (sections/lq-sticky-shop-bar.liquid)
   [data-lq-sticky-shop-bar] (+ data-hide="selector list") gets .is-visible once the first section in
   <main> (other than the bar's own) has scrolled above the viewport, unless an element matching
   data-hide is on screen. Toggles aria-hidden / inert with visibility.
   ===================================================================== */
const bars = new Map();

/** @param {Element} el */
const inView = (el) => {
  const r = el.getBoundingClientRect();
  return (r.width || r.height) && r.top < window.innerHeight && r.bottom > 0;
};

/** @param {HTMLElement} bar */
function update(bar) {
  if (window.Shopify?.designMode) {
    bar.classList.add('is-visible');
    return;
  }
  const own = bar.closest('.shopify-section');
  const first = Array.from(document.querySelectorAll('main .shopify-section')).find((s) => s !== own && !s.contains(bar));
  const past = first ? first.getBoundingClientRect().bottom < 0 : window.scrollY > window.innerHeight * 0.8;
  const hideSel = bar.dataset.hide;
  let blocked = false;
  if (hideSel) {
    try {
      blocked = Array.from(document.querySelectorAll(hideSel)).some((el) => el !== bar && !el.contains(bar) && inView(el));
    } catch {
      blocked = false;
    }
  }
  const show = past && !blocked;
  bar.classList.toggle('is-visible', show);
  bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  bar.inert = !show;
}

let ticking = false;
const onScroll = () => {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(() => {
    ticking = false;
    for (const bar of bars.keys()) update(bar);
  });
};

/** @param {ParentNode} scope */
function init(scope = document) {
  for (const bar of scope.querySelectorAll('[data-lq-sticky-shop-bar]')) {
    if (!(bar instanceof HTMLElement) || bars.has(bar)) continue;
    bars.set(bar, true);
    update(bar);
  }
}

if (!window.__lqStickyShopBar) {
  window.__lqStickyShopBar = true;
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', (e) => { if (e.target instanceof HTMLElement) init(e.target); });
  document.addEventListener('shopify:section:unload', (e) => {
    if (!(e.target instanceof HTMLElement)) return;
    for (const bar of bars.keys()) if (e.target.contains(bar)) bars.delete(bar);
  });
  init();
}
